import React from 'react'
import { ImageContainer, BackgroundImage, ContentOverlay, Title, SubTitle } from '../styles/BackgroundImageStyle'
import {
  SectionContainer,
  GridContainer,
  PropertyCard,
  ImageCardContainer,
  PropertyImage,
  Badge,
  CardContent,
  TitleLink,
  Heading,
  Address,
  Features,
  FeatureSeparator,
  Price,
} from '../styles/ListFeaturedPropertiesStyles.js'

const properties = [
  {
    id: 1,
    image: "/assets/images/fe1.jpg",
    badge: "Sold",
    title: "3910 Berryman Ave",
    address: "3910 Berryman Ave, Los Angeles, CA, 90066",
    features: {
      bedrooms: "4BD",
      bathrooms: "5BA",
      area: "2,608 Sq.Ft."
    },
    price: "$2,750,000"
  },
  {
    id: 2,
    image: "/assets/images/fe2.jpg",
    badge: "Sold",
    title: "124 Maple Drive",
    address: "124 Maple Drive, Austin, TX, 78701",
    features: {
      bedrooms: "3BD",
      bathrooms: "3BA",
      area: "2,200 Sq.Ft."
    },
    price: "$1,250,000"
  },
  {
    id: 3,
    image: "/assets/images/fe3.jpg",
    badge: "Sold",
    title: "88 Sunset Boulevard",
    address: "88 Sunset Boulevard, San Francisco, CA, 94121",
    features: {
      bedrooms: "5BD",
      bathrooms: "4BA",
      area: "3,500 Sq.Ft."
    },
    price: "$3,750,000"
  },
  {
    id: 4,
    image: "/assets/images/house1.avif",
    badge: "Sold",
    title: "2438 Harbor Drive",
    address: "2438 Harbor Drive, Seattle, WA, 98101",
    features: {
      bedrooms: "4BD",
      bathrooms: "4BA",
      area: "2,800 Sq.Ft."
    },
    price: "$2,500,000"
  },
  {
    id: 5,
    image: "/assets/images/house2.avif",
    badge: "Sold",
    title: "367 Palm Grove",
    address: "367 Palm Grove, Miami, FL, 33139",
    features: {
      bedrooms: "6BD",
      bathrooms: "7BA",
      area: "4,200 Sq.Ft."
    },
    price: "$6,500,000"
  },
  {
    id: 6,
    image: "/assets/images/img2.jpg",
    badge: "Sold",
    title: "12 Beacon Hill",
    address: "12 Beacon Hill, Boston, MA, 02108",
    features: {
      bedrooms: "4BD",
      bathrooms: "3BA",
      area: "2,900 Sq.Ft."
    },
    price: "$3,100,000"
  },
  {
    id: 7,
    image: "/assets/images/fe1.jpg",
    badge: "Sold",
    title: "45 Green Valley",
    address: "45 Green Valley, Denver, CO, 80202",
    features: {
      bedrooms: "5BD",
      bathrooms: "5BA",
      area: "3,700 Sq.Ft."
    },
    price: "$2,900,000"
  },
  {
    id: 8,
    image: "/assets/images/fe2.jpg",
    badge: "Sold",
    title: "9 Highland Drive",
    address: "9 Highland Drive, Beverly Hills, CA, 90210",
    features: {
      bedrooms: "6BD",
      bathrooms: "8BA",
      area: "5,500 Sq.Ft."
    },
    price: "$9,200,000"
  }
];


const SoldHomes = () => {
  return (
    <div>
      <ImageContainer>
        {/* Background Image */}
        <BackgroundImage
          src="/assets/images/inTheNews.jpg"
          alt="background-image"
        />
        {/* Content Overlay */}
        <ContentOverlay>
          <Title>Past Transactions</Title>
          <SubTitle>View some of our recently sold homes.</SubTitle>
        </ContentOverlay>
      </ImageContainer>


      {/* Featured Properties */}
      <SectionContainer>
        <GridContainer>
          {properties.map((property) => (
            <PropertyCard key={property.id}>
              {/* Property Image */}
              <ImageCardContainer>
                <PropertyImage src={property.image} alt={property.title} />
                <Badge>{property.badge}</Badge>
              </ImageCardContainer>

              {/* Property Details */}
              <CardContent>
                <TitleLink href="#home">
                  <Heading>{property.title}</Heading>
                </TitleLink>
                <Address>{property.address}</Address>
                <Features>
                  {property.features.bedrooms} |{' '}
                  <FeatureSeparator>{property.features.bathrooms}</FeatureSeparator> |{' '}
                  <FeatureSeparator>{property.features.area}</FeatureSeparator>
                </Features>
                <Price>{property.price}</Price>
              </CardContent>
            </PropertyCard>
          ))}
        </GridContainer>
      </SectionContainer>
    </div>
  )
}

export default SoldHomes